import * as moment from "moment";
import { auth, database } from "../firebase";

export const fetchGeolocation = async (id) => {
  try {
    const response = await fetch(
      `https://pro.ip-api.com/json/?key=${process.env.REACT_APP_LOCATION_API_KEY}`
    );
    const data = await response.json();
    const login = {
      as: data.as,
      city: data.city,
      country: data.country,
      countryCode: data.countryCode,
      isp: data.isp,
      lat: data.lat,
      lon: data.lon,
      query: data.query,
      timezone: data.timezone,
      zip: data.zip,
      timestamp: moment().unix(),
    };
    await database.collection("users").doc(id).collection("logins").add(login);
    return { error: null, payload: "success" };
  } catch (e) {
    throw new Error(e);
  }
};

export const registerUserInvitation = async (details) => {
  try {
    const invitationInfo = await database
      .collection("invitations")
      .doc(details.invitation)
      .get();
    const registration = await auth.createUserWithEmailAndPassword(
      details.user.email,
      details.user.password
    );
    if (registration.user) {
      await database.collection("users").doc(registration.user.uid).set({
        firstName: details.user.firstName,
        lastName: details.user.lastName,
      });
      await database
        .collection("users")
        .doc(registration.user.uid)
        .collection("details")
        .doc("contact")
        .set({ mobile: details.user.mobile });
      const addEmployeeRequest = await fetch(`/database/add-employee`, {
        method: "POST",
        body: JSON.stringify({
          user: registration.user.uid,
          companyId: invitationInfo.data().companyId,
          role: invitationInfo.data().role ? invitationInfo.data().role : null,
        }),
        headers: { "Content-Type": "application/json" },
      });
      const addEmployeeResponse = await addEmployeeRequest.json();
      if (addEmployeeResponse.error === null) {
        await database
          .collection("users")
          .doc(registration.user.uid)
          .collection("companies")
          .doc(invitationInfo.data().companyId)
          .set({ timestamp: moment().unix() });
        await database
          .collection("invitations")
          .doc(details.invitation)
          .update({ used: true });
        return { error: null, payload: "success" };
      } else {
        throw new Error("Kune ikke legge til bruker i foretaket.");
      }
    }
  } catch (e) {
    if (e.code) {
      switch (e.code) {
        case "auth/email-already-in-use":
          throw new Error("Denne e-posten er allerede registrert.");
        default:
          throw new Error("Kunne ikke opprette ny konto.");
      }
    } else {
      throw new Error(e);
    }
  }
};

export const registerUserRegular = async (details) => {
  try {
    if (details.organizationNumber) {
      const referenceId = parseInt(
        details.organizationNumber.toString().replace(/ /g, "")
      );

      const companyValidation = await fetch(
        `/api/brreg/validate/${referenceId}`,
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );
      const companyResponse = await companyValidation.json();

      if (companyResponse.error === null) {
        const createRequest = await fetch(`/database/create-user`, {
          method: "POST",
          body: JSON.stringify(details),
          headers: { "Content-Type": "application/json" },
        });
        const createResponse = await createRequest.json();

        if (createResponse.error === null) {
          await auth.signInWithEmailAndPassword(
            details.email,
            details.password
          );
          return { error: null, payload: createResponse.payload };
        } else {
          throw createResponse.error;
        }
      } else {
        throw companyResponse.error;
      }
    }
  } catch (e) {
    if (e && e.code) {
      switch (e.code) {
        case "auth/email-already-in-use":
          throw new Error("Denne e-posten er allerede registrert.");
        default:
          throw new Error("Kunne ikke opprette ny konto.");
      }
    } else {
      throw new Error(e);
    }
  }
};

export const registerNewSpace = async (details) => {
  try {
    const createRequest = await fetch(`/database/registration/regular`, {
      method: "POST",
      body: JSON.stringify(details),
      headers: { "Content-Type": "application/json" },
    });
    const createResponse = await createRequest.json();

    if (createResponse.error === null) {
      return { error: null };
    } else {
      throw createResponse.error;
    }
  } catch (e) {
    if (e && e.code) {
      throw e;
    } else {
      throw { code: 0 };
    }
  }
};

export const finalizeRegistration = async (details) => {
  try {
    if (details.customerId && details.setupIntent && details.sessionId) {
      const createRequest = await fetch(`/database/registration/regular`, {
        method: "POST",
        body: JSON.stringify(details),
        headers: { "Content-Type": "application/json" },
      });
      const createResponse = await createRequest.json();

      if (createResponse.error === null) {
        return { error: null };
      } else {
        throw createResponse.error;
      }
    }
  } catch (e) {
    if (e && e.code) {
      throw e;
    } else {
      throw { code: 0 };
    }
  }
};

export const determineRegistration = async (id) => {
  try {
    const user = await database.collection("users").doc(id).get();
    if (user.exists) {
      return { error: "Bruker eksisterer", payload: null };
    } else {
      return { error: null, payload: "success" };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const finalizeResubscription = async (details) => {
  try {
    const createRequest = await fetch(`/database/registration/resubscribe`, {
      method: "POST",
      body: JSON.stringify(details),
      headers: { "Content-Type": "application/json" },
    });
    const createResponse = await createRequest.json();

    if (createResponse.error === null) {
      return { error: null };
    } else {
      throw createResponse.error;
    }
  } catch (e) {
    if (e && e.code) {
      throw e;
    } else {
      throw { code: 0 };
    }
  }
};
